export default "__VITE_ASSET__DHpSqDy6__"